module.exports = __webpack_public_path__ + "img/class4.602921a2.webp";